import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'simple-react-modal'
import Isvg from 'react-inlinesvg'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

// Components
import Footer from '../components/Footer'
import Header from '../components/Header'
import Video from '../components/Header/Video'
import Button from '../components/Commons/Button'

import Loading from '../sass/images/Ball.svg'
import img01 from '../sass/images/landpage/01.png'
import img02 from '../sass/images/landpage/02.png'
import img03 from '../sass/images/landpage/03.png'
import img04 from '../sass/images/landpage/04.png'
import img05 from '../sass/images/landpage/05.png'
import img06 from '../sass/images/landpage/06.png'
import img07 from '../sass/images/landpage/07.png'
import img08 from '../sass/images/landpage/08.png'
import img09 from '../sass/images/landpage/09.png'
import img10 from '../sass/images/landpage/10.png'
import img11 from '../sass/images/landpage/11.png'
import img12 from '../sass/images/landpage/12.png'
import img13 from '../sass/images/landpage/13.png'
import img14 from '../sass/images/landpage/14.png'
import hand from '../sass/images/landpage/hand.png'
import handMobile from '../sass/images/landpage/hand_mobile_2x.png'
import logoLang from '../sass/images/landpage/logo-land.png'
import iconPlus from '../sass/images/landpage/icon-show.svg'
import iconMail from '../sass/images/landpage/icon-mail.svg'

import iconLongArrow from '../sass/icons/icon-long-arrow.svg'
import iconUpArrow from '../sass/icons/arrow-up.svg'
import iconSmallBar from '../sass/icons/icon-small-bar.svg'

import { getLandpage } from '../api/landpage'

class LandingPage extends Component {

  static contextTypes = {
    t: PropTypes.func.isRequired
  }

  state = {
    slug: '',
    title: 'Faça propaganda no Facebook. Só que do jeito certo.',
    subtitle: 'Transforme seus fãs, seguidores, colaboradores, amigos ou parceiros em aliados da sua marca.',
    image: 'https://s3.amazonaws.com/cdn.talkative.media/ladnpages/cf9d2f1f-bc34-41d5-afc9-ab9cafcd01ac.jpg',
    errors: false,
    isLoading: true,
    open: ''
  }

  componentDidMount() {
    document.getElementById('app-body').classList.add('landpage-body')
    getLandpage(this.props.location.pathname.split('/')[1], response => this.setState({...response, isLoading: false}))
  }

  componentWillUnmount() {
    document.getElementById('app-body').classList.remove('landpage-body')
  }

  render() {
    const { history } = this.props
    const { errors, isLoading, title, subtitle, open } = this.state

    const handleOpen = index => {
      this.setState({open: Number(index)})
    }

    return ([
      <div className="landpage" style={{minHeight: '100vh'}}>
        {(!errors && !isLoading) && ([
          <Header name="home-header site-header" key="header">

            <div className="container jumbotron">
              <div className="col-12_md-6 content center">
                <h1 style={{ textAlign: 'center', width: '100%'}}>
                  {title}
                </h1>
              </div>
            </div>

            <div className="container grid">
              <div className="grid">

                <div className="call-to-action  col-6_md-6_sm-12">
                  <div className="grid-center">
                    <img src={hand} alt="" className="hide-mobile hand" />
                  </div>
                </div>

                <div className="call-to-action col-6_md-6_sm-12">
                  <div className="grid-xs-12 content center">
                    <p>
                      {subtitle}
                    </p>
                    <Button name="submit" id="submit" type="button" text="Quero testar!" onClick={() => history.push(this.context.t('/checkout'))} />
                    <p>e faça teste do talkative grátis <strong>por 30 dias</strong></p>
                  </div>
                  <img src={handMobile} alt="" className="hide-desktop hand" />
                </div>

              </div>
            </div>

          </Header>,

          <section className="video-section">
            <div className="grid container">
              <div className="col-6_md-6_sm-12 video-content">
                  <p>Assista ao vídeo <br/> e saiba mais sobre o</p>
                  <img src={logoLang} alt=""/>
                <Isvg src={iconLongArrow} className="arrow right" />
              </div>
              <div className="col-6_md-6_sm-12">
                <div className="grid-center call-video padding">
                  <Video videoId="OyM9E7CesP4" background={require('../sass/images/video-bg.png')} />
                </div>
              </div>
            </div>
          </section>,

          <section className="landpage-section intro" style={{marginBottom: '40px'}}>
            <div className="container padding" style={{backgroundColor: '#fff', borderRadius: '0.5rem'}}>
              <div className="grid-1">
                <div className="col-12 left">
                  <Isvg src={iconSmallBar} className="bar" />
                  <h2>O que você quer <strong>melhorar</strong> nas redes sociais do seu negócio?</h2>
                  <p>As redes sociais oferecem à sua marca a chance de melhorar o relacionamento com o seu público e, claro, de fazer negócio. Essa não é uma tarefa fácil, mas o Talkative está aqui para te ajudar. Clique no problema que mais se parece com o seu e veja o que podemos fazer por você.</p>
                  <Isvg src={iconLongArrow} className="arrow right" />
                </div>
              </div>
            </div>
          </section>,

          <section className="landpage-section items" style={{marginBottom: '100px'}}>
            <div className="container" style={{backgroundColor: '#fff', borderRadius: '0.5rem'}}>
              <div className={classNames({"grid": true, "double-line": true, "open": open === 0})} onClick={handleOpen.bind(this, 0)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img01} alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>01</strong>
                  </div>
                  <div>
                    <h3>Você posta e ninguém curte? Ninguém comenta? Ninguém compartilha?</h3>
                    <p>Talkative organiza sua base de fãs, seguidores, colaboradores ou parceiros, garantindo um alcance de 100% da sua base. E mais: você pode premiar por tarefas cumpridas, fazendo sua comunicação ir mais longe.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": false, "open": open === 1})} onClick={handleOpen.bind(this, 1)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img02} className="img-02" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>02</strong>
                  </div>
                  <div>
                    <h3>Seus posts não geram negócio?</h3>
                    <p>Você sabia que postagens de amigos tem 4x mais credibilidade que postagens de marcas ou empresas?  Com Talkative você aumenta a credibilidade e o alcance de suas postagens organizando sua base de amigos.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": false, "open": open === 2})} onClick={handleOpen.bind(this, 2)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img03} className="img-03" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>03</strong>
                  </div>
                  <div>
                    <h3>Cansado de gastar com mídia?</h3>
                    <p>Midia é pagar para ter atenção. Sem falar que você nunca sabe se sua mensagem chegou mesmo ao público final. Com Talkative você transforma fãs, seguidores, colaboradores, amigos ou parceiros em divulgadores</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": true, "open": open === 3})} onClick={handleOpen.bind(this, 3)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img04} className="img-04" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>04</strong>
                  </div>
                  <div>
                    <h3>As redes sociais não estão dando o resultado esperado para seu negócio?</h3>
                    <p>Redes sociais são uma grande oportunidade de comunicação, principalmente para quem não tem verba para as mídias tradicionais. Mas se não fizer do jeito certo, pode ser perda, de tempo e dinheiro. Talkative organiza sua presença digital com baixo custo.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": false, "open": open === 4})} onClick={handleOpen.bind(this, 4)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img05} className="img-05" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>05</strong>
                  </div>
                  <div>
                    <h3>Ninguém vê seu conteúdo?</h3>
                    <p>Você foi lá, caprichou na foto ou no vídeo, fez aquele texto com todo carinho, postou e... nada. Um likezinho aqui ou ali, nenhum comentário, nenhum compartilhamento. Talvez o problema não seja seu conteúdo, e sim, a maneira como ele é divulgado. Vamos falar sobre Talkative? </p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": true, "open": open === 5})} onClick={handleOpen.bind(this, 5)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img06} className="img-06" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>06</strong>
                  </div>
                  <div>
                    <h3>Você tem muitos fãs ou seguidores, mas não consegue transformar isso em resultados?</h3>
                    <p>Se você tem uma boa base de fãs, seguidores, ou uma empresa com muitos colaboradores, uma causa com muita gente engajada, você já tem o mais difícil. Agora que tal conhecer uma plataforma que organiza isso e transforma em força de comunicação?</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": true, "open": open === 6})} onClick={handleOpen.bind(this, 6)}>
                <div className="col-3_sm-12 grid-center image">
                  <img className="img-07" src={img07} alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>07</strong>
                  </div>
                  <div>
                    <h3>Gostaria de ver seus colaboradores ajudando sua empresa a vender mais?</h3>
                    <p>Empresas de grande e médio porte tem em seus próprios colaboradores e parceiros uma força muito poderosa. Talkative ajuda a transformar essa base em um potencializador da sua comunicação, aumentando a credibilidade e o alcance de suas publicações.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": false, "open": open === 7})} onClick={handleOpen.bind(this, 7)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img08} className="img-08" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>08</strong>
                  </div>
                  <div>
                    <h3>Quer transformar seus clientes em divulgadores?</h3>
                    <p>Já pensou em transformar seus clientes em divulgadores? Ah, mas porque eles iriam fazer isso, você poderia questionar? Você pode premiar. Imagina se um aplicativo onde seus clientes divulgassem suas postagens e fossem pontuando para trocar por prêmios. Pronto, você imaginou o Talkative.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": false, "open": open === 8})} onClick={handleOpen.bind(this, 8)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img09} alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>09</strong>
                  </div>
                  <div>
                    <h3>Como organizar sua divulgação no WhatsApp?</h3>
                    <p>Se bobear, o whatsapp hoje tem mais audiência que a TV. E por ali tem de tudo, uma mega confusão de fotos, áudios, vídeos e mensagens. E você lá no meio, tentando vender seu peixe. E se eu disser que Talkative ajuda você a organizar sua comunicação digital e ficar no controle? Quer saber mais?</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": true, "open": open === 9})} onClick={handleOpen.bind(this, 9)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img10} className="img-10" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>10</strong>
                  </div>
                  <div>
                    <h3>Quer levar seu negócio para as redes sociais e não sabe como?</h3>
                    <p>Pra muita gente, rede social é como se um videogame, com alto grau de dificuldade. São muitos controles, muitas variáveis, muitas palavras em inglês.  Por isso surgiu Talkative. Um aplicativo fácil de usar, que organiza sua vida nas redes sociais.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": false, "open": open === 10})} onClick={handleOpen.bind(this, 10)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img11} alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>11</strong>
                  </div>
                  <div>
                    <h3>Ninguém visita seu site?</h3>
                    <p>Seu site tá lindo. Tá fácil de navegar. Tem todo seu conteúdo lá. Quem entrar, vai saber tudo sobre sua empresa. Mas, e se ninguém entrar lá? A gente sabe que as pessoas passam a maior parte do tempo nas redes sociais, então é lá que Talkative por ajudar a gerar visitas no seu site.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": true, "open": open === 11})} onClick={handleOpen.bind(this, 11)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img12} className="img-12" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>12</strong>
                  </div>
                  <div>
                    <h3>Ninguém baixou seu app? Baixaram mas não usam?</h3>
                    <p>Gastou um bom dinheiro desenvolvendo o aplicativo pro seu negócio e mais dinheiro pra fazer as pessoas baixarem só pra ver elas não usá-lo mais depois? Rodando a API do Talkative dentro do seu aplicativo você irá criar retenção e fidelização do seu usuário por meio de entrega de conteúdo e gamificação, fazendo os usuários usarem ele com muito mais frequência.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": false, "open": open === 12})} onClick={handleOpen.bind(this, 12)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img13} className="img-13" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>13</strong>
                  </div>
                  <div>
                    <h3>Quer modernizar seu programa de fidelidade?</h3>
                    <p>Programas de fidelidade podem funcionar muito bem para todos os tamanhos de empresas. O maior problema é gerenciar esses programas. Talkative faz isso de maneira fácil e intuitiva, como se fosse um joguinho. E o melhor: para ganhar pontos, as pessoas só precisam fazer o que fazem sempre nas redes sociais: curtir, comentar, postar e compartilhar.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>
              <div className={classNames({"grid": true, "double-line": true, "open": open === 13})} onClick={handleOpen.bind(this, 13)}>
                <div className="col-3_sm-12 grid-center image">
                  <img src={img14} className="img-14" alt="" />
                </div>
                <div className="col-12_sm-12 content">
                  <div>
                    <strong>14</strong>
                  </div>
                  <div>
                    <h3>Precisa de ajuda para divulgar seus produtos e serviços nas redes sociais?</h3>
                    <p className="p-14">Se seu produto fosse um gatinho fofinho, um cãozinho engraçado ou um bebê lindinho, provavelmente você divulgaria facilmente nas redes sociais. Mas se você não trabalha com nada disso, você precisa de uma boa ferramenta para melhorar seu desempenho nas redes. Você precisa de Talkative.</p>
                  </div>
                  <div className="show-more">
                    <span>temos a solução <Isvg src={iconPlus}/></span>
                  </div>
                </div>
              </div>

              <div className="grid newsletter-container">
                <div className="col-7_sm-12 description">
                  <Isvg src={iconMail} />
                  <p>Quer receber dicas para dominar ainda mais as redes sociais?</p>
                </div>

                <div className="col-5_sm-12 form">
                  <div id="mc_embed_signup">
                  <form action="https://media.us17.list-manage.com/subscribe/post?u=f6bd7113cebdd4c61a0a712a9&amp;id=b8d9bf8b6e" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" novalidate>
                    <label>Assine nossa newsletter:</label>
                      <div id="mc_embed_signup_scroll">
                        <div className="mc-field-group">
                          <input type="email" placeholder={this.context.t('Digite seu e-mail')} defaultValue="" name="EMAIL" className="required email" id="mce-EMAIL" />
                        </div>
                        <div id="mce-responses" className="clear">
                          <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                          <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
                        </div>
                        <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true"><input type="text" name="b_f6bd7113cebdd4c61a0a712a9_b8d9bf8b6e" tabIndex="-1" value="" /></div>
                        <button type="submit" name="subscribe" id="mc-embedded-subscribe" className="button">
                          <Isvg src={iconUpArrow} />
                        </button>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </section>,

          <section className="container cta-container">
            <div className="grid-center">
              <Button id="submit" type="button" text="Quero testar!" name="submit btn-test" onClick={() => history.push(this.context.t('/checkout'))} />
            </div>
          </section>
        ])}
        {(!!errors && !isLoading) && (
          <Header name="home-header site-header" style={{paddingBottom: '150px'}} key="header">
            <div className="container">
              <div className="grid-center">
                 <div className="col-8_md-10 grid-column content center">
                    <h1 style={{ textAlign: 'center', width: '100%'}}>
                      Oops - Erro 404
                    </h1>
                    <p>Não conseguimos encontrar a página que você procurava... Clique <Link to="/">aqui</Link> para voltar ao início</p>
                 </div>
              </div>
            </div>
          </Header>
        )}
        <Modal show={isLoading} containerStyle={{background: 'none', width: '64px', height: '64px', margin: '18% auto'}}>
          <Isvg src={Loading} />
        </Modal>
      </div>,
      <Footer />
    ])
  }
}



export default LandingPage



// WEBPACK FOOTER //
// ./src/pages/landing-page.js